import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';
import { useIsCurrentUserAdmin } from '@ms/yammer-hooks/dist/users';

type UseHasCommunityAgentPreviewBanner = () => boolean;
export const useHasCommunityAgentPreviewBanner: UseHasCommunityAgentPreviewBanner = () => {
  const isPreviewExperimentEnabled = useAndReportExperimentTreatment('CommunityAgentPublicPreview') === 'enabled';
  const isNetworkAdmin = useIsCurrentUserAdmin();

  return isPreviewExperimentEnabled && isNetworkAdmin;
};
